<template>
  <v-card>
    <v-toolbar flat>
      <v-tabs v-model="tab">
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab v-for="item in items" :key="item">{{ item }}</v-tab>
      </v-tabs>
    </v-toolbar>

    <v-tabs-items v-model="tab">
      <v-tab-item v-for="(item, index) in items" :key="item">
        <v-card>
          <div v-if="index === 0">
            <ModalSelectMicro />
          </div>
          <div v-if="index === 1">
            <ModalSelectCamera />
          </div>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import ModalSelectCamera from './ModalSelectCamera.vue'
import ModalSelectMicro from './ModalSelectMicro.vue'

export default {
  name: 'TabsDevices',

  components: {
    ModalSelectCamera,
    ModalSelectMicro
  },

  data() {
    return {
      tab: null,
      items: this.$t('rooms.devices')
    }
  }
}
</script>
